import { ViewBlacklistDto } from '../../../dto/viewblacklist/viewblacklistdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface ViewBlacklistRequest extends APIRequest
{
    getViewBlacklistRequest(): ViewBlacklistDto;
}

export class ViewBlacklistRequestImpl extends APIRequestDtoImpl implements ViewBlacklistRequest
{
    constructor(private viewBlacklistData: ViewBlacklistDto)
    {
        super();
    }

    getViewBlacklistRequest(): ViewBlacklistDto
    {
        return this.viewBlacklistData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/viewblacklist/viewblacklistrequest.tsx